export default {
  name: 'graff',
  appId: 'wxc9a643121000b22b',
  wechatId: '217',
  baseUrl: 'https://graff.estore.d1miao.com/'
};